export enum TypeModule{
    Logo,
    Esp32,
    S7
}